export default "__VITE_ASSET__BA9ifKaf__"